import { CircularProgress } from '@mui/material';
import { Controller } from 'react-hook-form';
import { AsyncPaginate } from 'react-select-async-paginate';
import { useAsyncSelectField } from './useAsyncSelectField';

export const AsyncSelectField = ({
  name,
  url,
  control,
  optionsMap,
  responseKey,
  controllerProps,
  loadOptionsOnMenuOpen = false,
  fetchOptionsOnFirstOpen = false,
  formatValue = v => v,
  ...props
}) => {
  const { defaultLoadOptions, selectRef, options } = useAsyncSelectField({
    url,
    responseKey,
    optionsMap,
    loadOptionsOnMenuOpen,
    fetchOptionsOnFirstOpen,
  });

  return (
    <Controller
      name={name}
      control={control}
      {...controllerProps}
      render={({ field: { onChange, onBlur, value } }) => (
        <AsyncPaginate
          styles={{
            control: baseStyles => ({
              ...baseStyles,
              zIndex: 0,
              '&:hover': {
                borderColor: '#464646',
              },
              borderRadius: '5px',
              width: 'auto',
            }),
            singleValue: base => ({
              ...base,
              borderRadius: 6,
              color: '#B7B5BE',
              fontSize: '15px',
              display: 'flex',
            }),
            menu: provided => ({
              ...provided,
              zIndex: 3,
            }),
          }}
          theme={theme => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              primary25: '#e9e9ea',
              primary: '#0A6CCF',
              width: 'auto',
            },
          })}
          loadOptions={defaultLoadOptions}
          noOptionsMessage={() => 'Nada encontrado'}
          loadingMessage={() => 'Carregando...'}
          onBlurResetsInput={false}
          onCloseResetsInput={false}
          loadOptionsOnMenuOpen={loadOptionsOnMenuOpen}
          debounceTimeout={500}
          defaultOptions={options}
          menuPosition="fixed"
          classNamePrefix="select"
          isSearchable={true}
          selectRef={selectRef}
          components={{
            LoadingIndicator: () => (
              <CircularProgress
                color="inherit"
                size={20}
                sx={{ marginRight: 1 }}
              />
            ),
          }}
          isClearable={true}
          autoload={false}
          value={value}
          onChange={onChange}
          onBlur={v => {
            onBlur(v);
            props?.onBlur && props.onBlur(props);
          }}
          {...props}
        />
      )}
    />
  );
};
